(() => {
  const button = document.querySelector('[data-snl-whatsapp-floating]');
  if (!button) return;
  function readContext() {
    try {
      return JSON.parse(document.querySelector('[data-snl-whatsapp-context]')?.textContent || 'null');
    } catch {
      return null;
    }
  }

  function selectedVariant(product) {
    const picker = document.querySelector(
      `#MainContent variant-picker[data-product-id="${product.id}"][data-template-product-match="true"]`
    );
    if (picker) {
      const values = [...picker.querySelectorAll('.variant-option')].map((option) =>
        option.querySelector('input:checked')?.value ??
        option.querySelector('select')?.value ??
        option.querySelector('[data-testid="variant-option-single-value"]')?.textContent.trim()
      );
      if (values.length) {
        // Read checked options immediately: the URL and fetched variant JSON may
        // still describe the previous color while the section request is pending.
        return product.variants.find((variant) =>
          variant.options.length === values.length && variant.options.every((value, index) => value === values[index])
        );
      }
    }
    const variantId = new URL(location.href).searchParams.get('variant') || product.initialVariantId;
    return product.variants.find((variant) => variant.id === variantId);
  }

  function updateMessage() {
    const context = readContext();
    if (!context) return;
    const greeting = `Ciao ${context.contact},`;
    let lines;
    // Use the public canonical URL, excluding marketing parameters or session data.
    let url = context.url;
    if (context.pageType === 'product' && context.product) {
      const product = context.product;
      const variant = selectedVariant(product);
      lines = [greeting, `sto guardando ${product.title}.`];
      if (variant && !product.defaultVariant) lines.push(`Variante: ${variant.title}.`);
      if (variant?.sku) lines.push(`Codice articolo: ${variant.sku}.`);
      lines.push(variant?.available === false
        ? 'Questa variante risulta esaurita: è previsto un riassortimento?'
        : 'Potresti darmi qualche informazione prima di acquistare?');
      const productUrl = new URL(product.url, location.origin);
      if (variant) productUrl.searchParams.set('variant', variant.id);
      url = productUrl.href;
    } else if (context.pageType === 'collection') {
      lines = [greeting, `sto guardando la collezione ${context.collectionTitle || context.title}.`, 'Potresti aiutarmi a scegliere?'];
    } else if (context.pageType === 'page' && context.pageHandle === 'b2b') {
      lines = [greeting, 'sono interessato a una collaborazione B2B con Stephen New Line.', 'Vorrei informazioni sulle forniture per rivenditori.'];
    } else if (context.pageType === 'cart') {
      lines = [greeting, 'avrei bisogno di aiuto per completare il mio acquisto sul vostro sito.'];
    } else if (context.pageType === 'index') {
      lines = [greeting, 'vorrei informazioni sui prodotti Stephen New Line. Puoi aiutarmi?'];
    } else if (context.pageType === 'page' && ['contact', 'contatti'].includes(context.pageHandle)) {
      lines = [greeting, 'vorrei mettermi in contatto con Stephen New Line per alcune informazioni.'];
    } else {
      lines = [greeting, `sto consultando la pagina “${context.title}” e vorrei qualche informazione.`];
    }
    const href = `https://wa.me/${context.phone}?text=${encodeURIComponent([...lines, url].join('\n'))}`;
    if (button.href !== href) button.href = href;
  }

  // Keep the actual href ready for touch, keyboard, and opening a new tab.
  document.addEventListener('change', updateMessage);
  window.addEventListener('popstate', updateMessage);
  ['pointerdown', 'focus', 'contextmenu', 'click'].forEach((event) => button.addEventListener(event, updateMessage));
  let banner;
  let stickyBar;
  const stickyResize = new ResizeObserver(() => schedule());
  let frame;
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  const attributes = new MutationObserver(schedule);
  function update() {
    frame = undefined;
    updateMessage();
    const nextBanner = document.getElementById('shopify-pc__banner');
    if (nextBanner !== banner) {
      resize.disconnect();
      attributes.disconnect();
      banner = nextBanner;
      if (banner) {
        resize.observe(banner);
        attributes.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
    }
    const box = banner?.getBoundingClientRect();
    const buttonBox = button.getBoundingClientRect();
    const overlapsHorizontally = box && box.left < buttonBox.right && box.right > buttonBox.left;
    const visible = box && box.width > 0 && box.height > 0 && getComputedStyle(banner).visibility !== 'hidden';
    let offset = visible && overlapsHorizontally ? Math.max(0, innerHeight - box.top + 12) : 0;
    const nextStickyBar = document.querySelector('.sticky-add-to-cart__bar');
    if (nextStickyBar !== stickyBar) {
      stickyResize.disconnect();
      stickyBar = nextStickyBar;
      if (stickyBar) stickyResize.observe(stickyBar);
    }
    if (stickyBar) {
      const rect = stickyBar.getBoundingClientRect();
      const styles = getComputedStyle(stickyBar);
      const showing = stickyBar.dataset.stuck === 'true' || (Number(styles.opacity) > 0 && rect.top < innerHeight);
      if (showing && rect.width > 0 && rect.height > 0 && rect.left < buttonBox.right && rect.right > buttonBox.left) {
        // Reserve the final bar position even while it animates in, then keep
        // that space until its exit transition has finished.
        offset = Math.max(offset, rect.height + (parseFloat(styles.bottom) || 0) + 12);
      }
    }
    button.style.setProperty('--snl-whatsapp-offset', `${offset}px`);
  }
  // Consent can be injected after the theme has loaded or removed after a choice.
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-stuck', 'data-variant-available'],
  });
  document.addEventListener('transitionend', (event) => {
    if (event.target.matches?.('.sticky-add-to-cart__bar')) schedule();
  });
  window.addEventListener('resize', schedule, { passive: true });
  update();
})();
